// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-ZGl_","rootParamsCollapsed":"styles_rootParamsCollapsed__Pqhg9","rootPreviewFull":"styles_rootPreviewFull__280GV","loader":"styles_loader___WoPB"};